import React, { useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import FullScreenButton from './FullScreenButton';
import ContainerMasterGrid from './ContainerMasterGrid';
import {
  CONTAINER_MASTER_CATEGORIES,
  CONTAINER_MASTER_TAB_LABELS,
  type ContainerMasterCategory,
} from '../utils/containerDispatchMaster';

interface ContainerMasterPageProps {
  isFullScreen: boolean;
  setIsFullScreen: (v: boolean) => void;
}

const ContainerMasterPage: React.FC<ContainerMasterPageProps> = ({
  isFullScreen,
  setIsFullScreen,
}) => {
  const [tab, setTab] = useState(0);
  const category: ContainerMasterCategory = CONTAINER_MASTER_CATEGORIES[tab];

  return (
    <div
      tabIndex={0}
      style={{
        width: '100%',
        maxWidth: '100%',
        margin: 0,
        padding: '12px 10px',
        display: 'flex',
        flexDirection: 'column',
        height: isFullScreen ? '100vh' : 'calc(100vh - 48px)',
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ flex: '0 0 auto' }}>
        <h2 style={{ textAlign: 'center', marginBottom: 16, color: '#1976d2' }}>컨테이너 마스터 관리</h2>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 1, minHeight: 40 }}
          variant="scrollable"
          scrollButtons="auto"
        >
          {CONTAINER_MASTER_CATEGORIES.map(cat => (
            <Tab key={cat} label={CONTAINER_MASTER_TAB_LABELS[cat]} />
          ))}
        </Tabs>
      </div>

      <div style={{ flex: '1 1 0', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <ContainerMasterGrid
          key={category}
          category={category}
          valueHeader={CONTAINER_MASTER_TAB_LABELS[category]}
        />
      </div>

      <FullScreenButton isFullScreen={isFullScreen} setIsFullScreen={setIsFullScreen} />
    </div>
  );
};

export default ContainerMasterPage;
